import { useEffect, useState, useCallback } from 'react';
import { Card, Table, Button, Form, Row, Col, Badge, Alert, Spinner } from 'react-bootstrap';
import { api } from '../api/client';
import { formatDateTime } from '../shared/dateFormat';

const STATUSES = ['all', 'new', 'contacted', 'converted', 'dropped'];
const SETTABLE = ['new', 'contacted', 'converted', 'dropped'];
const STATUS_VARIANT = {
  new: 'primary', contacted: 'info', converted: 'success', dropped: 'secondary',
};

export default function AdminDemoRequests() {
  const [rows, setRows] = useState([]);
  const [status, setStatus] = useState('all');
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState({ type: '', text: '' });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      setRows(await api.get('/admin/demo-requests?status=' + status));
    } catch (e) { setMsg({ type: 'danger', text: e.message }); }
    finally { setLoading(false); }
  }, [status]);
  useEffect(() => { load(); }, [load]);

  const setRowStatus = async (id, next) => {
    try {
      await api.put(`/admin/demo-requests/${id}`, { status: next });
      setMsg({ type: 'success', text: `Marked as ${next}.` });
      await load();
    } catch (e) { setMsg({ type: 'danger', text: e.message }); }
  };

  const filtered = rows.filter((r) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return [r.parent_name, r.student_name, r.phone, r.email, r.city, r.locality, r.subject, r.standard]
      .some((v) => (v || '').toLowerCase().includes(q));
  });

  return (
    <>
      <h3 className="mb-3">Demo Requests</h3>
      {msg.text && <Alert variant={msg.type} dismissible onClose={() => setMsg({ type: '', text: '' })}>{msg.text}</Alert>}

      <Card className="shadow-sm mb-3">
        <Card.Body>
          <Row>
            <Col md={5}><Form.Control placeholder="Search name / phone / email / locality" value={search} onChange={(e) => setSearch(e.target.value)} /></Col>
            <Col md={3}>
              <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
                {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
              </Form.Select>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {loading ? <div className="text-center py-4"><Spinner /></div> : (
        <Table bordered hover responsive className="bg-white">
          <thead className="table-dark">
            <tr>
              <th>Received</th><th>Parent</th><th>Student</th><th>Phone</th><th>Email</th>
              <th>City / Locality</th><th>Standard</th><th>Subject</th><th>Status</th><th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && <tr><td colSpan={10} className="text-center text-muted">No demo requests</td></tr>}
            {filtered.map((r) => (
              <tr key={r.id}>
                <td className="small">{formatDateTime(r.created_at)}</td>
                <td>{r.parent_name}</td>
                <td>{r.student_name}</td>
                <td><a href={`tel:${r.phone}`}>{r.phone}</a></td>
                <td>{r.email ? <a href={`mailto:${r.email}`}>{r.email}</a> : <span className="text-muted">-</span>}</td>
                <td>{[r.city, r.locality].filter(Boolean).join(' / ') || '-'}</td>
                <td>{r.standard}</td>
                <td>{r.subject || '-'}</td>
                <td><Badge bg={STATUS_VARIANT[r.status] || 'secondary'}>{r.status}</Badge></td>
                <td>
                  <Form.Select size="sm" value={r.status} onChange={(e) => setRowStatus(r.id, e.target.value)}>
                    {SETTABLE.map((s) => <option key={s} value={s}>{s}</option>)}
                  </Form.Select>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
}
